import { Button } from '@/components/ui/button';
import React, { useState } from 'react';
import AddMemberModal from '@/js/components/modals/AddMemberModal';
import { ChevronLeft } from 'lucide-react';

const contractStatus = 'Approved By Team';

const status = (val) => (
  <div
    className={`inline-flex gap-2 p-1 ${val === 'Contract Sent For Team Approval' && 'border border-[#01a6ff] w-64'} ${val === 'Approved By Team' && 'border border-[#179b12] w-40'} justify-center rounded-full items-center`}
  >
    <div
      className={`w-2 h-2 rounded-full ${val === 'Contract Sent For Team Approval' && 'bg-[#01a6ff]'} ${val === 'Approved By Team' && 'bg-[#179b12]'}`}
    ></div>
    <div
      className={`${val === 'Contract Sent For Team Approval' && 'text-[#01a6ff]'} ${val === 'Approved By Team' && 'text-[#179b12]'} font-semibold`}
    >
      {contractStatus}
    </div>
  </div>
);

const statusButton = (val) => {
  return (
    <Button
      className={`${val === 'Contract Sent For Team Approval' && 'bg-gray-100 text-gray-400 border border-gray-400 hover:bg-gray-100'} ${val === 'Approved By Team' && 'bg-darkPurple text-white hover:bg-darkerPurple'}`}
      disabled={val === 'Contract Sent For Team Approval'}
    >
      Send To Manufacturer
    </Button>
  );
};

const approvalStatus = (val) => {
  return (
    <div
      className={`inline-flex gap-2 p-1 ${
        val === 'Approved' && 'border border-[#179b12] w-32'
      } ${val === 'Rejected' && 'bg-[#fef0e8] w-32'} ${
        val === 'Pending' && 'border border-[#d1a21f] w-32'
      } justify-center rounded-full items-center`}
    >
      <div
        className={`w-2 h-2 rounded-full ${
          val === 'Approved' && 'bg-[#179b12]'
        } ${val === 'Rejected' && 'bg-[#ec6a13]'} ${
          val === 'Pending' && 'bg-[#d1a21f]'
        }`}
      ></div>
      <div
        className={`${
          val === 'Approved' && 'text-[#179b12]'
        } ${val === 'Rejected' && 'text-[#ec6a13]'} ${
          val === 'Pending' && 'text-[#d1a21f]'
        } font-semibold`}
      >
        {val}
      </div>
    </div>
  );
};

const tableData = [
  {
    upload_by: 'CNC Components',
    revision: '1',
    upload_date: '12 Dec 2025',
    contract: 'View Contract',
    status_button: statusButton(contractStatus),
    status: status(contractStatus),
  },
];
const tableTeamApproval = [
  {
    member_name: 'Name 1',
    email: 'Name1@gmail.com',
    date: '12 Dec 2025',
    approval_status: approvalStatus('Approved'),
  },
  {
    member_name: 'Name 2',
    email: 'Name2@gmail.com',
    date: '12 Dec 2025',
    approval_status: approvalStatus('Rejected'),
  },
  {
    member_name: 'Name 3',
    email: 'Name3@gmail.com',
    date: '12 Dec 2025',
    approval_status: approvalStatus('Pending'),
  },
];

const ContractStatusScreen = ({
  setScreen,
  contract,
  setContract,
  setField,
}) => {
  const [showModal, setShowModal] = useState(false);

  const handleActionClick = (action) => {
    if (action === 'Add Member') setShowModal(true);
  };

  return (
    <div className="py-8">
      <div className="flex gap-4 items-center mb-6">
        <ChevronLeft
          className="h-5 w-5 hover:cursor-pointer"
          onClick={() => {
            setField('Contract');
            setScreen('ALL_PARTS');
          }}
        />
        <h1 className="text-lg font-medium">
          Create Contract (Contract #{contract.contract})
        </h1>
      </div>
      <div className="mt-6 overflow-hidden">
        <div className="bg-veryVeryLightPurple rounded-lg border border-gray-300 grid grid-cols-6 gap-4 p-5 items-center font-medium text-sm text-center text-gray-800 mb-4">
          <div>Uploaded By</div>
          <div>Revision</div>
          <div>Upload Date</div>
          <div>Status</div>
          <div>Contract</div>
          <div>Status</div>
        </div>
        <div className="grid grid-cols-6 gap-4 p-4 items-center text-gray-400 font-semibold text-sm text-center mt-2 ">
          <div>{tableData[0].upload_by}</div>
          <div>{tableData[0].revision}</div>
          <div>{tableData[0].upload_date}</div>
          <div>{tableData[0].status}</div>
          <div className="text-darkPurple cursor-pointer">
            {tableData[0].contract}
          </div>
          <div>{tableData[0].status_button}</div>
        </div>
        <div>
          <Button className="bg-white mt-8 w-48 border border-darkerPurple font-semibold text-darkerPurple hover:bg-gray-50 transition-all ease-in duration-300">
            Upload Revised Document
          </Button>
        </div>

        <div className="bg-gray-50 p-4 mt-6">
          <div className="bg-gray-100 text-darkPurple p-2">Team Approval</div>
          <div className="bg-gray-100 mt-4 rounded-lg border border-gray-300 grid grid-cols-4 gap-4 p-5 items-center font-medium text-sm text-center text-gray-800 mb-4">
            <div>Member Name</div>
            <div>Team Member Email</div>
            <div>Date</div>
            <div>Status</div>
          </div>
          {tableTeamApproval.map((item, index) => {
            const uniqueKey = `default-${index}`;
            return (
              <div
                key={uniqueKey}
                className="grid grid-cols-4 gap-4 p-4 items-center text-gray-500 text-sm text-center bg-white mt-2"
              >
                <div>{item.member_name}</div>
                <div>{item.email}</div>
                <div>{item.date}</div>
                <div>{item.approval_status}</div>
              </div>
            );
          })}
          <Button
            className="bg-white mt-8 w-32 border border-darkerPurple font-semibold text-darkerPurple hover:bg-gray-50 transition-all ease-in duration-300"
            onClick={() => handleActionClick('Add Member')}
          >
            Add Members
          </Button>
          <AddMemberModal
            open={showModal}
            onClose={() => {
              setShowModal(false);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default ContractStatusScreen;
